import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359394/image-11_lrqjla.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359407/image-12_kv9bt4.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359407/image-13_h3kxda.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">

        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 md:mb-6 mt-2 text-[#152C24]">EDUCATION</h1>

        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281942/image-4_qnctse.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <div className="flex-1">
          <section className="bg-white p-6">
            <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
              <strong className="font-bold text-black">EDUCATION & TRAINING INSTITUTIONS: </strong>
              How can they benefit?
            </h2>

            <h2 className="font-bold text-[32px] text-black mb-6">
              Education stakeholders (like agricultural colleges, training centers, researchers, or extension trainers) can benefit from using the Farmnet App:
            </h2>

            <div className="md:space-y-10 text-[32px] text-black mt-10">
              <div>
                <strong>1. Real-World Learning Platform</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Gives students and trainees access to real-time agricultural data from actual farms.</li>
                  <li>Helps them learn about modern farming practices, crop cycles, market trends, and agritech tools.</li>
                </ul>
              </div>

              <div>
                <strong>2. Digital Extension & Outreach</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Educators can use Farmnet to send learning content, videos, or best practices directly to farmers.</li>
                  <li>Supports remote learning and field-based training without needing to travel.</li>
                </ul>
              </div>

              <div>
                <strong>3. Practical Exposure for Students</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Students can engage with real farmers, track farm performance, or offer advisory services as part of fieldwork or internships.</li>
                  <li>Creates a two-way learning exchange between students and farmers.</li>
                </ul>
              </div>

              <div>
                <strong>4. Access to Agricultural Innovations</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Educators and researchers stay updated on the latest agri-tech tools, input use, and digital solutions in use by farmers.</li>
                  <li>Encourages the integration of smart farming and digital agriculture into curricula.</li>
                </ul>
              </div>

              <div>
                <strong>5. Data for Research and Curriculum Development</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Access to farm-level data on yields, inputs, weather, and practices for research projects.</li>
                  <li>Use insights to develop case studies, training manuals, and real-life learning modules.</li>
                </ul>
              </div>

              <div>
                <strong>6. Collaboration with Development Projects</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Partner with NGOs or government programs using Farmnet for joint training and outreach.</li>
                  <li>Engage in capacity-building efforts targeting youth, women, or agribusiness owners.</li>
                </ul>
              </div>

              <div>
                <strong>7. Monitoring Student Impact in the Field</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Track how student-led trainings or advisory sessions influence farmer practices and outcomes.</li>
                  <li>Use feedback for improving agricultural education delivery.</li>
                </ul>
              </div>

              <div>
                <strong>8. Promote Youth in Agriculture</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  <li>Helps institutions encourage youth participation in agribusiness by showing how digital tools like Farmnet can boost productivity and income.</li>
                  <li>Inspires the next generation of agri-entrepreneurs and tech-savvy farmers.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
  );
};

export default Solutions2;
